import {ShareButtons} from '../../../../../viscomjs/ui/ShareButtons';
import meta from '../../../../meta';
import share from '../../../../share';

const getCustomShareOptions = (url, customShareOptions, type) => {
    const customOptions = customShareOptions[type];
    if (!customOptions) return {};
    return {
        url: `${url}/share/share${type}.html`,
        title: customOptions.title,
        description: customOptions.description,
        image: `${url}/img/${customOptions.image}`,
        media: `${url}/img/${customOptions.image}`
    };
};

const SwitchOnShareButtons = doThat => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        ShareButtons(meta, [...document.querySelectorAll('[data-social]:not([data-share-type])')]);
        share.forEach((shareObj, index) => {
            ShareButtons(meta, [...document.querySelectorAll(`[data-social][data-share-type='${index}']`)], getCustomShareOptions(meta.url, share, index));
        });

        resolve(doThat);
    });
};

export {SwitchOnShareButtons};
